import { useState } from "react";
import { categories } from "@/mocks/categories";

export default function CategoryScroll() {
  const [selectedCategory, setSelectedCategory] = useState("");

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    setSelectedCategory(url);
    if (url) window.open(url, "_blank", "noopener,nofollow");
  };

  return (
    <section className="w-full bg-background-100 -mt-10 md:-mt-16 relative z-20 pt-12 md:pt-20 pb-16 md:pb-24">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-8 md:mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
              Categorias <span className="text-primary-500">CSSBuy</span>
            </h2>
            <p className="text-foreground-600 text-sm mt-2">
              Explore as nossas categorias de produtos verificados
            </p>
          </div>
          <span className="bg-foreground-950 text-white text-xs font-semibold px-4 py-1.5 rounded-full whitespace-nowrap mt-4 sm:mt-0">
            14 Categorias
          </span>
        </div>

        <div className="flex gap-4 overflow-x-auto pb-4 -mx-4 px-4 md:px-6" style={{ scrollbarWidth: "none" }}>
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-[170px] md:w-[210px] bg-white rounded-2xl overflow-hidden cursor-pointer group transition-all duration-300 hover:-translate-y-1 relative"
            >
              <div className="w-full h-[180px] md:h-[210px] overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={cat.namePt}
                  title={`${cat.namePt} CSSBuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-white font-bold text-sm drop-shadow-sm">
                  {cat.namePt}
                </h3>
                <p className="text-white/80 text-xs mt-0.5 drop-shadow-sm">
                  {cat.description}
                </p>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 flex justify-center">
          <div className="relative w-full max-w-md">
            <select
              value={selectedCategory}
              onChange={handleDropdownChange}
              className="w-full appearance-none bg-white border-2 border-primary-300 rounded-full px-6 py-3.5 text-foreground-700 text-sm font-semibold cursor-pointer focus:outline-none focus:border-primary-500 transition-colors duration-200"
            >
              <option value="">-- Selecionar Categoria --</option>
              {categories.map((cat) => (
                <option key={cat.id} value={cat.url}>
                  {cat.namePt} ({cat.name})
                </option>
              ))}
            </select>
            <div className="absolute right-5 top-1/2 -translate-y-1/2 pointer-events-none w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-down-s-line text-foreground-500"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}